<div class="overlay" (click)="close.emit()">
    <div class="popup" (click)="$event.stopPropagation()">
        <div class="popup-header">
            <span class="title">{{ isEditMode ? 'Edit PID' : title }}</span>
            <button class="close-button" (click)="resetForm(); close.emit()">×</button>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="popup-content">
            <!-- PID Selection -->
            <div class="header-row">
                <label class="popup-label">PID Name :</label>
                <app-dropdown [control]="form.get('pidName')" [options]="pidList" [placeholder]="'Select PID'"
                    [disabled]="isEditMode" [dataId]="'pidName'"></app-dropdown>
            </div>

            <hr class="divider" />

            @for (field of currentFields; track field) {
<div class="header-row">
                @if (field.fieldType !== 'toggle-group') {
<label class="popup-label">{{ field.fieldLabel }}
                    @if (field.fieldType === 'number' && field.min !== undefined && field.max !== undefined && field.fieldLabel!='') {
<span
                       
                        class="info-icon">
                        <i class="fa fa-info-circle"></i>
                        <div class="tooltip-number">
                            @if (field.min !== undefined) {
<div>Min: {{ field.min }}</div>
}
                            @if (field.max !== undefined) {
<div>Max: {{ field.max }}</div>
}
                        </div>
                    </span>
}
                    :</label>
}

                <!-- Number input -->
                @if (field.fieldType === 'number') {
<app-textbox [control]="form.get(field.fieldName)"
                    [type]="field.fieldType" [min]="field.min" [max]="field.max" [required]="field.required"
                    [placeholder]="field.placeholder || ''" [dataId]="field.fieldName"
                    [decimalSupport]="field.decimalSupport" [disabled]="!isEditMode"></app-textbox>
}

                <!-- Text input -->
                @if (field.fieldType === 'text') {
<app-textbox [control]="form.get(field.fieldName)"
                    [type]="field.fieldType" [required]="field.required" [placeholder]="field.placeholder || ''"
                    [dataId]="field.fieldName"></app-textbox>
}

                <!-- Dropdown -->
                @if (field.fieldType === 'dropdown') {
<app-dropdown [control]="form.get(field.fieldName)"
                    [options]="field.options" [placeholder]="field.placeholder" [required]="field.required"
                    [disabled]="false" [dataId]="field.fieldName"></app-dropdown>
}

                <!-- Toggle Group -->
                @if (field.fieldType === 'toggle-group') {
<div class="toggle-row">
                    @for (toggleField of field.toggles; track toggleField) {
<app-toggle-switch
                        [control]="form.get(toggleField.fieldName)" [label]="toggleField.fieldLabel"
                        [required]="toggleField.required" [dataId]="toggleField.fieldName"></app-toggle-switch>
}
                </div>
}

                <!-- Toggle -->
                @if (field.fieldType === 'toggle') {
<app-toggle-switch
                    [control]="form.get(field.fieldName)"></app-toggle-switch>
}
            </div>
}

            @if (currentFields.length > 0) {
<hr class="divider" />
}

            <div class="footer-buttons">
                <app-button label="Close" color="secondary" (clicked)="resetForm(); close.emit()"></app-button>
                <app-button label="Submit" color="primary" [disabled]="!isFormValid"
                    (clicked)="onSubmit()"></app-button>
            </div>
        </form>
    </div>
</div>